<td-wb-loading-indicator-panel>
  <td-wb-detailed-loading-indicator [displayDelay]="0" />
</td-wb-loading-indicator-panel>
